import { REGEXP_ONLY_DIGITS } from 'input-otp';
import { z } from 'zod';

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

// Components
import { useEffect, useRef, useState } from 'react';
import { useCotizador } from '../../../hooks/others/useCotizador.js';
import {
  useGenerateOTP,
  useValidateOTP,
} from '../../../services/apis/formularioOTP/formularioOTP.hook.js';
import {
  ButtonCustom,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from '../../atoms';
import { cn } from '../../../lib/tailwind-merge.js';
import axios from 'axios';

// Schemas
const FormModalSmsCodeSchema = z.object({
  codeSMS: z
    .string()
    .length(6, { message: 'El código debe tener exactamente 6 caracteres' }),
});

export function FormModalSmsCode({
  aceptacionVerificarModalOTP = () => null,
  paramsCodeOTP,
}) {
  const [errorCode, setErrorCode] = useState('');
  const { idOportunidad } = useCotizador();
  const form = useForm({
    resolver: zodResolver(FormModalSmsCodeSchema),
    defaultValues: {
      codeSMS: '',
    },
  });

  const validateCodeOTP = useValidateOTP();
  async function onSubmit(values) {
    validateCodeOTP.mutate(
      {
        idOportunidad: idOportunidad,
        code: values.codeSMS,
      },
      {
        onSuccess: () => {
          aceptacionVerificarModalOTP(true);
        },
        onError: error => {
          if (axios.isAxiosError(error)) {
            setErrorCode(error.response?.data?.message);
          }
        },
      },
    );
  }

  const habilitar = form.watch('codeSMS').length > 5;

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col items-center gap-3.5"
      >
        <FormField
          control={form.control}
          name="codeSMS"
          render={({ field }) => (
            <FormItem>
              <div className="text-center">
                <FormLabel className="text-base w-full">
                  Ingresa el código
                </FormLabel>
              </div>
              <FormControl>
                <InputOTP maxLength={6} pattern={REGEXP_ONLY_DIGITS} {...field}>
                  <InputOTPGroup>
                    <InputOTPSlot index={0} />
                    <InputOTPSlot index={1} />
                    <InputOTPSlot index={2} />
                    <InputOTPSlot index={3} />
                    <InputOTPSlot index={4} />
                    <InputOTPSlot index={5} />
                  </InputOTPGroup>
                </InputOTP>
              </FormControl>
              <p className="text-danger text-sm text-center w-full">
                {errorCode}
              </p>
            </FormItem>
          )}
        />

        <Contador paramsCodeOTP={paramsCodeOTP} />

        <ButtonCustom
          disabled={!habilitar}
          type="submit"
          text="Verificar"
          variant="text"
          className={cn(
            'bg-secondary text-white fontPSemiBold text-base  mt-3 cursor-pointer  hover:opacity-90',
            !habilitar
              ? 'bg-disabled text-disabled-content cursor-not-allowed'
              : '',
          )}
        />
      </form>
    </Form>
  );
}

function Contador({ paramsCodeOTP }) {
  const [contador, setContador] = useState(0);
  const intervaloRef = useRef(null);

  const generateCodeOTP = useGenerateOTP();

  async function postGenerateCodeOTP() {
    generateCodeOTP.mutate(paramsCodeOTP, {
      onSuccess: () => {
        inicializarContador();
      },
      onError: () => {
        setContador(0);
      },
    });
  }

  useEffect(() => {
    inicializarContador();
    return () => clearInterval(intervaloRef.current);
  }, []);

  async function inicializarContador() {
    clearInterval(intervaloRef.current);
    setContador(60);

    intervaloRef.current = setInterval(() => {
      setContador(prevContador => {
        if (prevContador <= 1) {
          clearInterval(intervaloRef.current);
          return 0;
        }
        return prevContador - 1;
      });
    }, 1000);
  }

  return (
    <div className="text-center h-14">
      {contador > 0 ? (
        <p className="h-full flex items-center">
          Reenviar código en:&nbsp;
          <span className="text-accent font-semibold">00:{contador}</span>
        </p>
      ) : (
        <ButtonCustom
          type="button"
          text="Reenviar código"
          variant="text"
          className="text-base text-secondary w-fit fontPSemiBold  underline  hover:bg-transparent"
          typeColor="general"
          onClick={postGenerateCodeOTP}
        />
      )}
    </div>
  );
}
